import { render, staticRenderFns } from "./UserTenants.vue?vue&type=template&id=23e6caf8&scoped=true"
import script from "./UserTenants.vue?vue&type=script&lang=js"
export * from "./UserTenants.vue?vue&type=script&lang=js"
import style0 from "./UserTenants.vue?vue&type=style&index=0&id=23e6caf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6caf8",
  null
  
)

export default component.exports